// Entitlement contract — moved verbatim from `src/components/constants/entitlements.ts`
// (the ENTITLEMENT catalog) and `src/types/index.ts` (the view/response types).
// Old paths re-export from here.

/**
 * Catalog of access entitlement IDs exposed by ml-scribe.
 *
 * Mirrors the code-defined catalog in
 * `ml-scribe/domains/access_entitlements/static_types.py`. IDs here must match
 * the backend exactly — they are persisted on entitlement attachment rows and
 * returned as `UserEntitlementView.id` / `.name`.
 *
 * When the backend adds or renames an entitlement, update this file in the
 * same PR. Consumers should reach the boolean state via
 * `useIsEntitlementEnabled(ENTITLEMENT.X)` (see
 * `src/hooks/entitlements/useIsEntitlementEnabled.ts`), not by hardcoding the
 * string.
 */
export const ENTITLEMENT = {
  EVIDENCE: 'evidence',
  SHADOW_HEIDI: 'shadow_heidi',
  ANALYTICS_DASHBOARD: 'enterprise.analytics_dashboard',
  CODER_SEAT: 'coder_seat',
  LETTER_FLOW: 'letter_flow',
  TRANSLATOR: 'translator',
  /** Heidi 2 access — TEAM + USER attachments (`HEIDI_II_ACCESS_ENTITLEMENT_TYPE_ID`). */
  HEIDI_II_ACCESS: 'heidi_ii_access',
  /** Revoke of Heidi 2 access — TEAM + USER attachments (`HEIDI_II_ACCESS_REVOKED_ENTITLEMENT_TYPE_ID`). */
  HEIDI_II_ACCESS_REVOKED: 'heidi_ii_access_revoked',
} as const;

export type EntitlementId = (typeof ENTITLEMENT)[keyof typeof ENTITLEMENT];

// Entitlements types
export enum EntitlementSourceType {
  ORGANIZATION = 'organization',
  TEAM = 'team',
  USER = 'user',
}

export interface EntitlementSourceView {
  source: EntitlementSourceType;
  id: string;
  name: string;
}

export interface UserEntitlementView {
  name: string;
  enabled: boolean;
  source: EntitlementSourceView | null;
}

export interface AccessEntitlementsResponse {
  entitlements: UserEntitlementView[];
}

// `MintCodingCaseAccessContextResponse` TRANSFERRED to
// `@heidi/coding/contracts` with its endpoint (the SCC inversion, ARCFE-986).
